import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardHeader } from 'reactstrap'
import DisabledDatePicker from 'domains/setting/molecules/disabled-date-picker'

const propTypes = {
  disabledDate: PropTypes.shape({
    id         : PropTypes.number.isRequired,
    code       : PropTypes.string.isRequired,
    data_type  : PropTypes.string,
    label      : PropTypes.string.isRequired,
    ui_type    : PropTypes.string,
    value      : PropTypes.arrayOf(PropTypes.string).isRequired,
    value_type : PropTypes.string
  }),
  onChangeDisabledDates : PropTypes.func,
  onUpdate              : PropTypes.func
}

const defaultProps = {
  onUpdate              : () => { },
  onChangeDisabledDates : () => { }
}


const DisabledDates = ({
  disabledDate,
  onChangeDisabledDates,
  onUpdate
}) => (
  <Card>
    <CardHeader>
      <h3>{ disabledDate.label }</h3>
    </CardHeader>
    <DisabledDatePicker
      disabledDates={ disabledDate }
      onUpdate={ onUpdate }
      onChangeDisabledDates={ (val) => onChangeDisabledDates(val, disabledDate.id) }
    />
  </Card>
)

DisabledDates.propTypes    = propTypes
DisabledDates.defaultProps = defaultProps

export default DisabledDates
